import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  ScrollView,
  StyleSheet,
  ActivityIndicator,
} from "react-native";
import React, { useEffect, useState } from "react";
import Ionicons from "@expo/vector-icons/Ionicons";
import { useStateContext } from "../lib/context";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import SelectDropdown from "react-native-select-dropdown";

const Checkout = ({ navigation }) => {
  const [total, setTotal] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [transporte, setTransporte] = useState("");
  const [transporteInfo, setTransporteInfo] = useState("");
  const [transporTel, setTransporTel] = useState("");
  const [pago, setPago] = useState("");
  const [eroResult, setEroResult] = useState("");
  const [drnResult, setDrnResult] = useState("");
  const [eroUrl, setEroUrl] = useState("");
  const [drnUrl, setDrnUrl] = useState("");
  const [loading, setLoading] = useState(false);

  const {
    cartItems,
    currentUser,
    setCartItems,
    promoEro,
    promoDrn,
    userID,
    isViajante,
    correoViajante,
  } = useStateContext();

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const docRef = doc(db, "users", currentUser);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          data.transporte ? setTransporte(data.transporte) : null;
          data.transporteInfo ? setTransporteInfo(data.transporteInfo) : null;
          data.transporTel ? setTransporTel(data.transporTel) : null;
          data.pago ? setPago(data.pago) : null;
        }
      } catch (e) {
        console.error("Error fetching config: ", e);
      }
    };
    fetchConfig();
  }, []);

  const transpoptions = [
    "Comisionista",
    "Transporte a acordar",
    "Retiro en Deposito",
  ];
  const pagoptions = ["Transferencia bancaria/deposito", "Contra reembolso"];

  const promoIdDrn = promoDrn;
  const promoIdEro = promoEro;

  const validateInput = (value, type) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    switch (type) {
      case "email":
        return emailRegex.test(value);
      case "number":
        return /^\d+$/.test(value);
      case "text":
        return /^[a-zA-Z\s]+$/.test(value);
      default:
        return false;
    }
  };

  const promoMatrix = [
    { not: "not" },
    { uno: 30, tres:  0, nueve: 0, dos: 10 },
    { uno: 30, tres: 30, nueve: 0, dos:  0 },
    { uno: 30, tres: 33, nueve: 0, dos: 10 },
    { uno: 25, tres: 25, nueve: 0, dos:  0 },
    { uno: 30, tres: 33, nueve: 0, dos: 10 },
    { uno: 32, tres: 36, nueve: 0, dos:  0 },
    { uno: 32, tres: 34, nueve: 0, dos: 10 },
    { uno: 34, tres: 38, nueve: 0, dos: 20 },
    { uno: 32, tres: 33, nueve: 0, dos: 10 },
    { uno: 34, tres: 34, nueve: 0, dos:  0 },
    { uno: 20, tres: 20, nueve: 0, dos:  0 },
    { uno: 32, tres: 34, nueve: 0, dos:  0 },
    { uno: 32, tres: 30, nueve: 0, dos: 10 },
    { uno: 28, tres: 28, nueve: 0, dos: 10 },
    { uno: 32, tres: 34, nueve: 0, dos:  0 },
    { uno: 30, tres: 33, nueve: 0, dos: 15 },
    { uno: 28, tres: 28, nueve: 0, dos: 10 },
    { uno: 32, tres: 30, nueve: 0, dos:  0 },
    { uno: 40, tres: 30, nueve: 0, dos: 10 },
  ];

  useEffect(() => {
    const newTotal = cartItems.reduce((sum, item) => {
      return sum + Number(item.price) * Number(item.quantity);
    }, 0);
    setTotal(newTotal);
  }, [cartItems]);

  useEffect(() => {
    const newTotal = cartItems.reduce((sum, item) => {
      const chu =
        item.type == "1"
          ? promoMatrix[promoIdEro].uno
          : item.type == "2"
            ? promoMatrix[promoIdDrn].dos
            : item.type == "3"
              ? promoMatrix[promoIdEro].tres
              : promoMatrix[promoIdEro].nueve;
      const temp = ((parseFloat(chu) * item.price) / 100).toFixed(2);
      return sum + Number(temp) * Number(item.quantity);
    }, 0);
    setDiscount(newTotal);
  }, [cartItems]);

  const prep = async () => {
    setLoading(true);
    let temp = "";
    let tempDrn = "";
    for (let i = 0; i < cartItems.length; i++) {
      const chu =
        cartItems[i].type == "1"
          ? promoMatrix[promoIdEro].uno
          : cartItems[i].type == "2"
            ? promoMatrix[promoIdDrn].dos
            : cartItems[i].type == "3"
              ? promoMatrix[promoIdEro].tres
              : promoMatrix[promoIdEro].nueve;

      let precio = (
        cartItems[i].price -
        (parseFloat(chu) * cartItems[i].price) / 100
      ).toFixed(2);
      let precioIVA = cartItems[i].price * 1.21;

      if (cartItems[i].type == "2") {
        tempDrn =
          tempDrn +
          "<detallepedido><cantidad>" +
          cartItems[i].quantity +
          "</cantidad><codigo>" +
          cartItems[i].sku +
          "</codigo><denominacion>" +
          cartItems[i].name +
          "</denominacion><incluye__iva>N</incluye__iva> <iva>21</iva><porbonif>" +
          chu +
          "</porbonif><precio>" +
          cartItems[i].price +
          "</precio><precio__con__iva>" +
          precioIVA +
          "</precio__con__iva></detallepedido>";
      } else {
        temp =
          temp +
          "<detallepedido><cantidad>" +
          cartItems[i].quantity +
          "</cantidad><codigo>" +
          cartItems[i].sku +
          "</codigo><denominacion>" +
          cartItems[i].name +
          "</denominacion><incluye__iva>N</incluye__iva> <iva>21</iva><porbonif>" +
          chu +
          "</porbonif><precio>" +
          cartItems[i].price +
          "</precio><precio__con__iva>" +
          precioIVA +
          "</precio__con__iva></detallepedido>";
      }
    }
    const end =
      "</detallePedido><sObservaciones></sObservaciones><sPersona__id>" +
      userID +
      "</sPersona__id><sPersonaliza></sPersonaliza><sTipo>Nota de Pedido</sTipo><sTransporte__id>0</sTransporte__id></documento>";
    const start = "<documento><detallePedido>";

    // Get URLs logic
    const erourl =
      "http://sa08.ddns.net:7780/AppAndroid/servlet/ServletAndroid?empresa=ero&usuario=consultaweb&clave=web3007&dato=enviodocumento&documento=" +
      start +
      temp +
      end;
    setEroUrl(erourl);

    const drnurl =
      "http://sa08.ddns.net:7780/AppAndroid/servlet/ServletAndroid?empresa=drn&usuario=consultaweb&clave=web3007&dato=enviodocumento&documento=" +
      start +
      tempDrn +
      end;
    setDrnUrl(drnurl);

    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    const xmlDataEro = start + temp + end;
    const xmlDataDrn = start + tempDrn + end;

    const fetchWithDelayProxy = async () => {
      try {
        // Fetch DRN
        fetch("https://erodistribuciones.com/proxyv2.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            baseUrl: "http://sa08.ddns.net:7780/AppRest/servlet/ServletAndroid",
            params: {
              empresa: "drn",
              usuario: "consultaweb",
              clave: "web3007",
              dato: "enviodocumento",
            },
            xml: xmlDataDrn,
          }),
        })
          .then((res) => res.json())
          .then((data) => {
            setDrnResult(data.response);
          })
          .catch((err) => console.error("Proxy error DRN:", err));

        await delay(2000);

        // Fetch ERO
        fetch("https://erodistribuciones.com/proxyv2.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            baseUrl: "http://sa08.ddns.net:7780/AppRest/servlet/ServletAndroid",
            params: {
              empresa: "ero",
              usuario: "consultaweb",
              clave: "web3007",
              dato: "enviodocumento",
            },
            xml: xmlDataEro,
          }),
        })
          .then((res) => res.json())
          .then((data) => {
            setEroResult(data.response);
          })
          .catch((err) => console.error("Proxy error ERO:", err));
      } catch (error) {
        console.error("Error during fetch:", error);
      }
    };

    fetchWithDelayProxy();
  };

  useEffect(() => {
    if (eroResult != "" && drnResult != "") {
      buy();
    }
  }, [eroResult, drnResult]);

  const buy = () => {
    const unique = currentUser + Date.now();

    // Save user preferences
    setDoc(
      doc(db, "users", currentUser),
      {
        transporte: transporte,
        transporteInfo: transporteInfo,
        transporTel: transporTel,
        pago: pago,
      },
      { merge: true },
    );

    // Save order
    setDoc(
      doc(db, "orders", unique),
      {
        viajante: isViajante ? correoViajante : "No",
        fecha: Date.now(),
        items: cartItems,
        matrix: promoMatrix,
        promoDrn: promoDrn,
        promoEro: promoEro,
        estado: "Procesando",
        total: total,
        discount: discount,
        user: currentUser,
        transporte: transporte,
        transporteInfo: transporteInfo,
        transporTel: transporTel,
        pago: pago,
        ero: eroResult,
        drn: drnResult,
        eroUrl: eroUrl,
        drnUrl: drnUrl,
      },
      { merge: true },
    )
      .then(() => {
        setCartItems([]);
        setLoading(false);
        navigation.navigate("Gracias", {
          pago: pago,
          total: total,
          discount: discount,
          transporte: transporte,
        });
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  return (
    <View style={localStyles.container}>
      <View style={localStyles.header}>
        <TouchableOpacity
          onPress={() => navigation.goBack()}
          style={localStyles.backButton}
        >
          <Ionicons name="arrow-back" size={24} color="#fff" />
        </TouchableOpacity>
        <Text style={localStyles.headerTitle}>Finalizar Compra</Text>
      </View>

      <ScrollView
        contentContainerStyle={localStyles.scrollContent}
        showsVerticalScrollIndicator={false}
      >
        {/* Order Items Summary */}
        <View style={localStyles.section}>
          <Text style={localStyles.sectionTitle}>Resumen del Pedido</Text>
          {cartItems.map((item, index) => {
            const chu =
              item.type == "1"
                ? promoMatrix[promoIdEro].uno
                : item.type == "2"
                  ? promoMatrix[promoIdDrn].dos
                  : item.type == "3"
                    ? promoMatrix[promoIdEro].tres
                    : promoMatrix[promoIdEro].nueve;

            const price = Number(item.price);
            const discontinuedPrice = price - (parseInt(chu) * price) / 100;
            const itemTotal = discontinuedPrice * item.quantity;

            return (
              <View key={index} style={localStyles.itemCard}>
                <View style={localStyles.itemInfo}>
                  <Text style={localStyles.itemName}>{item.name}</Text>
                  <Text style={localStyles.itemSku}>SKU: {item.sku}</Text>
                </View>
                <View style={localStyles.itemTotals}>
                  <Text style={localStyles.itemQty}>x{item.quantity}</Text>
                  <Text style={localStyles.itemPrice}>
                    ${itemTotal.toFixed(2)}
                  </Text>
                </View>
              </View>
            );
          })}
        </View>

        {/* Shipping Section */}
        <View style={localStyles.section}>
          <Text style={localStyles.sectionTitle}>Opción de Envío</Text>
          <View style={localStyles.inputGroup}>
            <SelectDropdown
              data={transpoptions}
              defaultValue={transporte}
              onSelect={(selectedItem, index) => setTransporte(selectedItem)}
              buttonTextAfterSelection={(selectedItem) => selectedItem}
              rowTextForSelection={(item) => item}
              defaultButtonText="Seleccionar envío"
              buttonStyle={localStyles.dropdownBtn}
              buttonTextStyle={localStyles.dropdownBtnTxt}
              dropdownStyle={localStyles.dropdownDropdown}
              rowStyle={localStyles.dropdownRow}
              renderDropdownIcon={(isOpened) => {
                return (
                  <Ionicons
                    name={isOpened ? "chevron-up" : "chevron-down"}
                    color={"#444"}
                    size={18}
                  />
                );
              }}
            />
          </View>

          {(transporte == "Transporte a acordar" ||
            transporte == "Comisionista") && (
            <View style={localStyles.subInputGroup}>
              <View style={localStyles.inputWrapper}>
                <Text style={localStyles.inputLabel}>Nombre</Text>
                <TextInput
                  onChangeText={setTransporteInfo}
                  value={transporteInfo}
                  style={localStyles.input}
                  placeholder="Nombre del transporte/comisionista"
                />
              </View>
              <View style={localStyles.inputWrapper}>
                <Text style={localStyles.inputLabel}>Teléfono</Text>
                <TextInput
                  onChangeText={(text) =>
                    validateInput(text, "number") || text.length <= 0
                      ? setTransporTel(text)
                      : null
                  }
                  value={transporTel}
                  style={localStyles.input}
                  placeholder="Teléfono de contacto"
                  keyboardType="numeric"
                />
              </View>
            </View>
          )}
        </View>

        {/* Payment Section */}
        <View style={localStyles.section}>
          <Text style={localStyles.sectionTitle}>Medio de Pago</Text>
          <View style={localStyles.inputGroup}>
            <SelectDropdown
              data={pagoptions}
              defaultValue={pago}
              onSelect={(selectedItem, index) => setPago(selectedItem)}
              buttonTextAfterSelection={(selectedItem) => selectedItem}
              rowTextForSelection={(item) => item}
              defaultButtonText="Seleccionar medio de pago"
              buttonStyle={localStyles.dropdownBtn}
              buttonTextStyle={localStyles.dropdownBtnTxt}
              dropdownStyle={localStyles.dropdownDropdown}
              rowStyle={localStyles.dropdownRow}
              renderDropdownIcon={(isOpened) => {
                return (
                  <Ionicons
                    name={isOpened ? "chevron-up" : "chevron-down"}
                    color={"#444"}
                    size={18}
                  />
                );
              }}
            />
          </View>
        </View>

        {/* Totals & Submit */}
        <View style={localStyles.footer}>
          <View style={localStyles.summaryRow}>
            <Text style={localStyles.summaryLabel}>Subtotal</Text>
            <Text style={localStyles.summaryValue}>${total.toFixed(2)}</Text>
          </View>
          {discount > 0 && (
            <View style={localStyles.summaryRow}>
              <Text style={localStyles.discountLabel}>Descuento</Text>
              <Text style={localStyles.discountValue}>
                - ${discount.toFixed(2)}
              </Text>
            </View>
          )}
          <View style={[localStyles.summaryRow, localStyles.totalRow]}>
            <Text style={localStyles.totalLabel}>Total Final (+IVA)</Text>
            <Text style={localStyles.totalValue}>
              ${(total - discount).toFixed(2)}
            </Text>
          </View>

          <TouchableOpacity
            style={[
              localStyles.submitButton,
              loading && localStyles.disabledButton,
            ]}
            onPress={prep}
            disabled={loading}
          >
            {loading ? (
              <ActivityIndicator color="#fff" />
            ) : (
              <>
                <Text style={localStyles.submitButtonText}>
                  Confirmar Pedido
                </Text>
                <Ionicons name="checkmark-circle" size={24} color="#fff" />
              </>
            )}
          </TouchableOpacity>

          <TouchableOpacity
            style={localStyles.secondaryButton}
            onPress={() => navigation.navigate("Store")}
            disabled={loading}
          >
            <Text style={localStyles.secondaryButtonText}>
              Volver a la tienda
            </Text>
          </TouchableOpacity>
        </View>

        <View style={{ height: 40 }} />
      </ScrollView>
    </View>
  );
};

export default Checkout;

const localStyles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#F4F6FD",
  },
  header: {
    backgroundColor: "#2a2a8e",
    paddingTop: 50,
    paddingBottom: 20,
    paddingHorizontal: 20,
    flexDirection: "row",
    alignItems: "center",
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  backButton: {
    padding: 4,
    marginRight: 12,
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#fff",
  },
  scrollContent: {
    padding: 20,
  },
  section: {
    marginBottom: 24,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#333",
    marginBottom: 12,
  },
  itemCard: {
    backgroundColor: "#fff",
    padding: 16,
    borderRadius: 12,
    marginBottom: 8,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 1,
  },
  itemInfo: {
    flex: 1,
  },
  itemName: {
    fontSize: 14,
    fontWeight: "600",
    color: "#333",
  },
  itemSku: {
    fontSize: 12,
    color: "#999",
  },
  itemTotals: {
    alignItems: "flex-end",
  },
  itemQty: {
    fontSize: 12,
    color: "#666",
  },
  itemPrice: {
    fontSize: 14,
    fontWeight: "600",
    color: "#2a2a8e",
  },
  inputGroup: {
    marginBottom: 12,
  },
  subInputGroup: {
    backgroundColor: "#fff",
    padding: 16,
    borderRadius: 12,
    gap: 12,
  },
  inputWrapper: {
    marginBottom: 8,
  },
  inputLabel: {
    fontSize: 12,
    fontWeight: "600",
    color: "#666",
    marginBottom: 4,
  },
  input: {
    borderWidth: 1,
    borderColor: "#E0E0E0",
    borderRadius: 8,
    padding: 12,
    fontSize: 14,
    backgroundColor: "#FAFAFA",
  },
  dropdownBtn: {
    width: "100%",
    backgroundColor: "#fff",
    borderRadius: 12,
    borderWidth: 1,
    borderColor: "#E0E0E0",
    height: 50,
  },
  dropdownBtnTxt: {
    color: "#333",
    textAlign: "left",
    fontSize: 14,
  },
  dropdownDropdown: {
    borderRadius: 12,
  },
  dropdownRow: {
    borderBottomColor: "#F4F6FD",
  },
  footer: {
    backgroundColor: "#fff",
    borderRadius: 16,
    padding: 20,
    marginTop: 10,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4,
  },
  summaryRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  summaryLabel: {
    fontSize: 14,
    color: "#666",
  },
  summaryValue: {
    fontSize: 14,
    fontWeight: "600",
    color: "#333",
  },
  discountLabel: {
    fontSize: 14,
    color: "#4CAF50",
    fontWeight: "500",
  },
  discountValue: {
    fontSize: 14,
    fontWeight: "600",
    color: "#4CAF50",
  },
  totalRow: {
    marginTop: 8,
    paddingTop: 12,
    borderTopWidth: 1,
    borderTopColor: "#f0f0f0",
    marginBottom: 20,
  },
  totalLabel: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#333",
  },
  totalValue: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#2a2a8e",
  },
  submitButton: {
    backgroundColor: "#2a2a8e",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 16,
    borderRadius: 12,
    gap: 10,
    shadowColor: "#2a2a8e",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 4,
  },
  submitButtonText: {
    color: "#fff",
    fontSize: 16,
    fontWeight: "bold",
  },
  disabledButton: {
    opacity: 0.7,
  },
  secondaryButton: {
    marginTop: 12,
    paddingVertical: 14,
    alignItems: "center",
  },
  secondaryButtonText: {
    color: "#666",
    fontSize: 14,
    fontWeight: "600",
  },
});
